import { Colors } from '@/constants/theme';
import { useBenchmarkingPresentation } from '@/hooks/useBenchmarkingPresentation';
import { BenchmarkingItem, useBenchmarkingStore } from '@/stores/benchmarking-store';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text } from 'react-native';
import { ScenarioDetail } from './scenario-detail';
import { ScenarioSkeleton } from './scenario-skeleton';
import { Card } from './ui/card';
import { IconSymbol } from './ui/icon-symbol';
import { View } from './ui/tw-wrappers';

interface BenchmarkingItemResultProps {
  values: Omit<BenchmarkingItem, 'id'>;
  index: number;
}

export function BenchmarkingItemResult({ values, index }: BenchmarkingItemResultProps) {
  const commonProps = useBenchmarkingStore(s => s.commonProps);
  const { t } = useTranslation();

  const { presentation, loading, error } = useBenchmarkingPresentation(commonProps, values);

  if (loading) {
    return (
      <View style={styles.resultsBox}>
        <ScenarioSkeleton count={1} />
      </View>
    );
  }

  if (error) {
    return (
      <View style={styles.emptyContainer}>
        <IconSymbol name='exclamationmark.error' size={24} color={Colors.light.error} />
        <Text style={styles.emptyTitle}>{t('home.scenarios.error')}</Text>
        <Text style={styles.emptyDescription}>{error}</Text>
      </View>
    );
  }

  if (!presentation) {
    return (
      <View style={styles.resultsBox}>
        <Card className='w-93' backgroundColor={'white'}>
          <View style={styles.emptyContainer}>
            <IconSymbol name='doc.text' size={38} color='#666' />
            <Text style={styles.emptyDescription}>{t('screens.benchmarking.empty.description')}</Text>
          </View>
        </Card>
      </View>
    );
  }

  return (
    <View style={styles.resultsBox}>
      <ScenarioDetail presentation={presentation} modelType={'benchmarking'} type={commonProps.scenario} />
    </View>
  );
}

const styles = StyleSheet.create({
  resultsBox: {
    flex: 1,
    marginTop: 36,
  },
  emptyContainer: {
    // paddingTop: 60,
    flex: 1,
    alignItems: 'center',
    padding: 20,
    gap: 8,
    minHeight: 775,
  },
  emptyTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#333',
    textAlign: 'center',
  },
  emptyDescription: {
    marginTop: 10,
    fontSize: 14,
    color: '#666',
    textAlign: 'center',
  },
});
